import { render, staticRenderFns } from "./QuotePrice.vue?vue&type=template&id=0968be6f&scoped=true&"
import script from "./QuotePrice.vue?vue&type=script&lang=js&"
export * from "./QuotePrice.vue?vue&type=script&lang=js&"
import style0 from "./QuotePrice.vue?vue&type=style&index=0&id=0968be6f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0968be6f",
  null
  
)

export default component.exports